package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.menu_card_import


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.hs_soft.runmynesto.domain.config.*
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.menu_card_model.MenuCardModel
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.UploadMenuCard
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.SubmitButtons
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px


@Composable
fun MenuCardImportTab(
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum
) {
    LaunchedEffect(Unit){
        event(OptionsEvent.GetVirtualCardInfo)
        event(OptionsEvent.GetProductSalesGroup(false))
        event(OptionsEvent.GetPrintersLocation)
        event(OptionsEvent.GetTemplateCategoryList)
    }

    Column(
        modifier = Modifier
            .fillMaxHeight()
            .fillMaxWidth()
            .padding(
                bottom =  Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    )
    {
        if (windowSizeMode == WindowSizeModeEnum.Desktop) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
            )
            {
                TopContent(
                    windowSizeMode = windowSizeMode,
                    clearDataLoading=state.clearMenuCardDataLoading,
                    onGenerateMenuCardButtonClick = {
                        event(OptionsEvent.OnGenerateMenuCardButtonClick)
                    },
                    menuCardAIGenerated = state.menuCardAIGenerated,
                    onMenuProductItemValueChange = { menuCard, id, key, value ->
                        event(OptionsEvent.OnMenuProductItemValueChange(menuCard, id, key, value))
                    },
                    onCancelImportMenuCardClick = {
                        event(OptionsEvent.ResetGenerateAIMenuCard)
                    },
                    onImportClick = { menuCard, ingredients ->
                        event(OptionsEvent.SaveMenuCard(menuCard, ingredients))
                    },
                    showGenerateAIMenuCardDialog = {
                        event(OptionsEvent.SetGenerateAIMenuCardDialogStatus(true))
                    },
                    getIngredients = {
                        event(OptionsEvent.GetIngredients)
                    },
                    ingredients = state.ingredients,
                    categories = state.templateCategoryListDropDown,
                    updateTemplateCategoryList = { categoriesDropDown, menuCard ->
                        event(OptionsEvent.UpdateTemplateCategoryList(categoriesDropDown, menuCard))
                    }
                )
            }
        } else {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
            ) {
                TopContent(
                    clearDataLoading=state.clearMenuCardDataLoading,
                    windowSizeMode = windowSizeMode,
                    onGenerateMenuCardButtonClick = {
                        event(OptionsEvent.OnGenerateMenuCardButtonClick)
                    },
                    menuCardAIGenerated = state.menuCardAIGenerated,
                    onMenuProductItemValueChange = { menuCard, id, key, value ->
                        event(OptionsEvent.OnMenuProductItemValueChange(menuCard, id, key, value))
                    },
                    onImportClick = { menuCard, ingredients ->
                        event(OptionsEvent.SaveMenuCard(menuCard, ingredients))
                    },
                    onCancelImportMenuCardClick = {
                        event(OptionsEvent.ResetGenerateAIMenuCard)
                    },
                    showGenerateAIMenuCardDialog = {
                        event(OptionsEvent.SetGenerateAIMenuCardDialogStatus(true))
                    },
                    getIngredients = {
                        event(OptionsEvent.GetIngredients)
                    },
                    ingredients = state.ingredients,
                    categories = state.templateCategoryListDropDown,
                    updateTemplateCategoryList = { categoriesDropDown, menuCard ->
                        event(OptionsEvent.UpdateTemplateCategoryList(categoriesDropDown, menuCard))
                    }
                )
            }
        }
    }
}


@Composable
private fun TopContent(
    windowSizeMode: WindowSizeModeEnum,
    clearDataLoading:Boolean,
    menuCardAIGenerated: MenuCardModel,
    onGenerateMenuCardButtonClick:() -> Unit,
    onMenuProductItemValueChange:(MenuCardModel, Int, String, String) -> Unit,
    onCancelImportMenuCardClick: () -> Unit,
    onImportClick: (MenuCardModel, List<Ingredients>?) -> Unit,
    showGenerateAIMenuCardDialog:()->Unit,
    getIngredients: () -> Unit,
    ingredients: List<Ingredients>?,
    categories: MutableList<TemplateCategoryModel>,
    updateTemplateCategoryList: (MutableList<TemplateCategoryModel>, MenuCardModel) -> Unit
) {
    LaunchedEffect(Unit){
        getIngredients()
    }
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight(),
        horizontalAlignment = Alignment.Start,
    )
    {
        MediumContentTitle(
            title = Strings.current().menuCard,
            marginBottom = 0.px,
            marginTop =if (windowSizeMode== WindowSizeModeEnum.PHONE)
                Dimen.mediumPadding else 0.px
        )
        if (windowSizeMode== WindowSizeModeEnum.PHONE){
            Column(
                modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = Dimen.mediumPadding),
                horizontalAlignment = Alignment.Start,
            )
            {

                GenerateButton(
                    onGenerateMenuCardButtonClick={
                        onGenerateMenuCardButtonClick()
                    }
                )

                SubmitButtons(
                    windowSize = windowSizeMode,
                    alignToRight = false,
                    loading =clearDataLoading,
                    isSubmitClickable = menuCardAIGenerated.items.isNotEmpty(),
                    arrangement = if (windowSizeMode== WindowSizeModeEnum.PHONE)
                            Arrangement.Start
                        else Arrangement.End
                    ,
                    onCancelClick = {
                        onCancelImportMenuCardClick()
                    },
                    onSubmitClick = {
                        onImportClick(menuCardAIGenerated, ingredients)
                    },
                )

            }
        }else{
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(bottom = Dimen.mediumPadding),
                verticalAlignment = Alignment.CenterVertically
            ) {


                GenerateButton(
                    onGenerateMenuCardButtonClick={
                        onGenerateMenuCardButtonClick()
                    }
                )

                SubmitButtons(
                    windowSize = windowSizeMode,
                    loading = clearDataLoading,
                    onCancelClick = {
                        onCancelImportMenuCardClick()
                                    },
                    onSubmitClick = {
                        onImportClick(menuCardAIGenerated, ingredients)
                    },
                    isSubmitClickable = menuCardAIGenerated.items.isNotEmpty(),
                    arrangement = Arrangement.End
                )
            }
        }

        Spacer()

        UploadMenuCard(
            modifier = Modifier,
            menuCard = menuCardAIGenerated,
            windowSizeMode = windowSizeMode,
            onMenuProductItemValueChange = onMenuProductItemValueChange,
            onCancelImportMenuCardClick = onCancelImportMenuCardClick,
            onImportClick = onImportClick,
            categories = categories,
            updateTemplateCategoryList = updateTemplateCategoryList
        )
    }
}

@Composable
private fun GenerateButton(
    onGenerateMenuCardButtonClick: () -> Unit
) {
    CustomButton(
        modifier = Modifier,
        icon = Res.PathIcon.star ,
        iconSize =Dimen.normalIconSize ,
        title = Strings.current().generate,
        buttonType = ButtonTypes.CONTAINED,
        onButtonClick = {
            onGenerateMenuCardButtonClick()
        }
    )
}

















